import { render, staticRenderFns } from "./paymentcensus.vue?vue&type=template&id=478519cc&"
import script from "./paymentcensus.vue?vue&type=script&lang=js&"
export * from "./paymentcensus.vue?vue&type=script&lang=js&"
import style0 from "./paymentcensus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports